import React from "react";
import stylesForOferta from "./stylesForOferta.module.css";
import Logo from "./icons/logo";
import SEO from "../components/seo";

const Oferta = () => {
  return (
    <>
      <SEO title="Пользовательское соглашение" />
      <div className={stylesForOferta.container}>
        <div className={stylesForOferta.logo}>
          <Logo />
        </div>
        <p>10.01.2022</p>
        <p className={stylesForOferta.title}>
          Пользовательское соглашение
        </p>{" "}
        <p>
          Настоящее Пользовательское соглашение (актуальная редакция соглашения,
          опубликованная по ссылке https://www.guidedao.xyz/) является публичной
          офертой и определяет условия использования сервисов ООО "МОСКОУ КОДИНГ
          СКУЛ" (ИНН 7725262648, ОГРН 1157746115438) (существующих и создаваемых
          в будущем) веб-сайта ООО "МОСКОУ КОДИНГ СКУЛ", доступного по ссылке
          https://www.guidedao.xyz/ (далее — Сайт), любыми пользователями сети
          Интернет, просматривающими Сайт (далее — Пользователи Сайта).
        </p>{" "}
        <p>
          Настоящее Пользовательское соглашение приравнивается к договору,
          составленному в письменной форме. Принимая настоящее Пользовательское
          соглашение, Пользователь выражает полное и безоговорочное согласие со
          всеми его условиями, в том числе, в части предоставления согласия на
          обработку персональных данных Пользователя на условиях, указанных в
          разделе 2 настоящего Пользовательского соглашения. В случае несогласия
          с данными условиями Пользователь должен покинуть Сайт.
        </p>{" "}
        <p>Общие положения</p>{" "}
        <p>
          — Настоящее Пользовательское соглашение вступает в силу с момента
          размещения его на Сайте и действует в отношении всей информации,
          размещенной на сайте в информационно-телекоммуникационной сети
          «Интернет».
        </p>{" "}
        <p>
          — Начиная использовать какой-либо сервис/его отдельные функции, либо
          пройдя процедуру регистрации, Пользователь считается принявшим условия
          Соглашения в полном объеме, без всяких оговорок и исключений. В случае
          несогласия Пользователя с какими-либо из положений Соглашения,
          Пользователь не вправе использовать Сайт. В случае если Администрацией
          Сайта были внесены какие-либо изменения в Соглашение, с которыми
          Пользователь не согласен, он обязан прекратить использование Сайта.
        </p>{" "}
        <p>Персональные данные</p>{" "}
        <p>
          — В случае если отдельные сервисы Сайта предусматривают ввод
          персональных данных, такие персональные данные хранятся и
          обрабатываются в соответствии с принципами и правилами обработки
          персональных данных, предусмотренными Федеральным законом Российской
          Федерации от 27 июля 2006 г. № 152-ФЗ «О персональных данных».
        </p>{" "}
        <p>
          — В отношении персональных данных сохраняется их конфиденциальность,
          кроме случаев добровольного предоставления Пользователем информации о
          себе для общего доступа неограниченному кругу лиц.
        </p>{" "}
        <p>
          — Сайт не передает персональные данные третьим лицам, если только
          такая передача не предусмотрена законодательством Российской
          Федерации.
        </p>{" "}
        <p>
          — Администрация Сайта принимает необходимые организационные и
          технические меры для защиты персональных данных от использования, не
          предусмотренного настоящим Пользовательским соглашением.
        </p>{" "}
        <p>
          — Использование Сайта регулируется настоящим Соглашением, а также
          Политикой конфиденциальности (Политика защиты и обработки персональных
          данных).
        </p>{" "}
        <p>Обязательства Пользователя</p>{" "}
        <p>
          — Пользователь соглашается не предпринимать действий и не оставлять
          комментарии и записи, которые могут рассматриваться как нарушающие
          законодательство Российской Федерации или нормы международного права,
          в том числе в сфере интеллектуальной собственности, авторских и/или
          смежных прав, общепринятые нормы морали и нравственности, а также
          любых действий, которые приводят или могут привести к нарушению
          нормальной работы части Сайта или Сайта в целом.
        </p>{" "}
        <p>
          — Использование материалов Сайта без согласия правообладателей не
          допускается.
        </p>
        <p>
          — При цитировании материалов Сайта, включая охраняемые авторские
          произведения, ссылка на Сайт обязательна.
        </p>
        <p>
          — Администрация Сайта не несет ответственности за посещение и
          использование Пользователем внешних ресурсов, ссылки на которые могут
          содержаться на Сайте.
        </p>
        <p>
          — Администрация Сайта не несет ответственности и не имеет прямых или
          косвенных обязательств перед Пользователем в связи с любыми возможными
          или возникшими убытками, связанными с любым содержанием Сайта,
          регистрацией авторских прав и сведениями о такой регистрации,
          доступными на Сайте или полученными через внешние сайты или ресурсы
          либо иные контакты Пользователя, в которые он вступил, используя
          размещенную на Сайте информацию или ссылки на внешние ресурсы.
        </p>
        <p>
          — Пользователь обязан немедленно уведомить ООО "МОСКОУ КОДИНГ СКУЛ" о
          любом случае несанкционированного (не разрешенного Пользователем)
          доступа к Сайту с использованием учетной записи Пользователя и/или о
          любом нарушении (подозрениях о нарушении) конфиденциальности своих
          средств доступа к учетной записи. В целях безопасности Пользователь
          обязан самостоятельно осуществлять безопасное завершение работы под
          своей учетной записью по окончании каждой сессии работы с элементами
          Сайта. ООО "МОСКОУ КОДИНГ СКУЛ" не отвечает за возможную потерю или
          порчу данных, а также другие последствия любого характера, которые
          могут произойти из-за нарушения Пользователем положений этой части
          Соглашения.
        </p>
        <p>— Пользователь обязан использовать свою учетную запись.</p>
        <p>
          — Пользователь не вправе воспроизводить, повторять и копировать,
          продавать и перепродавать, а также использовать для каких-либо
          коммерческих целей какие-либо части сервисов ООО "МОСКОУ КОДИНГ СКУЛ"
          (включая контент, доступный Пользователю посредством сервисов), или
          доступ к ним, кроме тех случаев, когда Пользователь получил такое
          разрешение от ООО "МОСКОУ КОДИНГ СКУЛ", либо когда это прямо
          предусмотрено пользовательским соглашением какого-либо сервиса.
        </p>
        <p>Исключительные права</p>
        <p>
          — Все объекты, доступные при помощи Сайта, в том числе элементы
          дизайна, текст, графические изображения, иллюстрации, видео, и другие
          объекты (далее – содержание Сайта), а также любой контент, размещенный
          на Сайте являются объектами исключительных прав ООО "МОСКОУ КОДИНГ
          СКУЛ", Пользователей и других правообладателей.
        </p>
        <p>
          — Использование контента, а также каких-либо иных элементов Сайта
          возможно только в рамках функционала, предлагаемого тем или иным
          сервисом. Никакие элементы содержания Сайта, а также любой контент,
          размещенный на Сайте, не могут быть использованы иным образом без
          предварительного разрешения правообладателя. Под использованием
          подразумеваются, в том числе: воспроизведение, копирование,
          переработка, распространение на любой основе, отображение во фрейме и
          т.д. Исключение составляют случаи, прямо предусмотренные
          законодательством РФ или условиями использования того или иного Сайта.
        </p>
        <p>
          — Использование Пользователем элементов содержания Сайта, а также
          любого контента для личного некоммерческого использования, допускается
          при условии сохранения всех знаков охраны авторского права, смежных
          прав, товарных знаков, других уведомлений об авторстве, сохранения
          имени (или псевдонима) автора/наименования правообладателя в
          неизменном виде, сохранении соответствующего объекта в неизменном
          виде. Исключение составляют случаи, прямо предусмотренные
          законодательством РФ.
        </p>
        <p>Прочие условия</p>
        <p>
          Пользователь использует Сайт на свой собственный риск. Все материалы
          на Сайте предоставляются «как есть». Администрация не принимает на
          себя никакой ответственности, в том числе за соответствие Сайта целям
          Пользователя;
        </p>
        <p>
          — Все возможные споры, вытекающие из настоящего Пользовательского
          соглашения или связанные с ним, подлежат разрешению в соответствии с
          законодательством Российской Федерации.
        </p>
        <p>
          — Бездействие со стороны Администрации Сайта в случае нарушения
          Пользователем положений Пользовательского соглашения не лишает
          Администрацию Сайта права предпринять позднее соответствующие действия
          в защиту своих интересов и защиту авторских прав на охраняемые в
          соответствии с законодательством материалы Сайта.
        </p>
        <p>
          — Администрация Сайта вправе в любое время в одностороннем порядке
          изменять условия настоящего Пользовательского соглашения. Такие
          изменения вступают в силу с момента размещения новой версии
          Пользовательского соглашения на сайте. При несогласии Пользователя с
          внесенными изменениями он обязан покинуть Сайт, прекратить
          использование материалов и сервисов Сайта.
        </p>
        <p>
          Утверждено: ООО "МОСКОУ КОДИНГ СКУЛ" (ИНН 7725262648,ОГРН
          1157746115438)
        </p>
        <p>Генеральный директор: Резвый Вадим Викторович</p>
      </div>
    </>
  );
};
export default Oferta;
